import { useGlobalSearchParams } from 'expo-router'
import { useEffect } from 'react'

export const useClearHeaderNotificationOnPushPressAction = (
    id: string | undefined,
    clear: () => void
): void => {
    const { pushNotificationId } = useGlobalSearchParams<{ pushNotificationId?: string }>()

    useEffect(() => {
        if (!pushNotificationId || pushNotificationId !== id) return

        clear()
    }, [pushNotificationId, id, clear])
}
